import TabbedView from './components/TabbedView';
import { TabView } from './components/TabbedView/TabbedView';
import HaveList from './tabs/HaveList';
import { useMyCards } from './hooks';
import './MyCards.css';
import WantList from './tabs/WantList';
import CollectionHeader from './components/CollectionHeader/CollectionHeader';
import { useHaveListFetchInfiniteQuery } from 'store/services/collectionList/haveList/haveListApi';
import { useWantListFetchInfiniteQuery } from 'store/services/collectionList/wantList/wantListApi';
import { useMemo } from 'react';
import { AssetUrls } from 'config/assets';
import { useDrawerLayout } from 'components/FilterPanel/useDrawerLayout';

const tabs: TabView[] = [
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src={AssetUrls.icons.misc.heart}
          alt="Want List"
          style={{ width: '16px', height: '16px' }}
        />
        Want List
      </div>
    ),
    content: <WantList />
  },
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src={AssetUrls.icons.misc.have}
          alt="Have List"
          style={{ width: '16px', height: '16px' }}
        />
        Have List
      </div>
    ),
    content: <HaveList />
  },
  // { title: 'Wish List', content: <div>Wish List</div> },
];

export const MyCards = () => {
  const { tabIndex, onTabIndexChange } = useMyCards();
  // Both tabs mount the shared filter rail on desktop, so the page reflows
  // left of it for as long as it is open (rail geometry, decision 4).
  const layout = useDrawerLayout({ cartOpen: false, railMounted: true });
  
  // Fetch data for stats calculation. Only the totals are read, so the lean
  // row shape is enough (Asana 1219915395102217).
  const { data: haveListData } = useHaveListFetchInfiniteQuery({ fields: 'list' });
  const { data: wantListData } = useWantListFetchInfiniteQuery({ fields: 'list' });
  
  // Calculate aggregated stats
  const stats = useMemo(() => {
    const haveListPages = haveListData?.pages || [];
    const wantListPages = wantListData?.pages || [];
    
    // Get total counts from the last page
    const haveListCount = haveListPages.length > 0 ? haveListPages[haveListPages.length - 1].totalCards : 0;
    const wantListCount = wantListPages.length > 0 ? wantListPages[wantListPages.length - 1].totalCards : 0;
    
    // Get total values from backend if available
    // Backend should provide totalValue in the response
    const wantListValue = wantListPages.length > 0 && (wantListPages[wantListPages.length - 1] as any).totalValue 
      ? (wantListPages[wantListPages.length - 1] as any).totalValue 
      : 0;
    
    const haveListValue = haveListPages.length > 0 && (haveListPages[haveListPages.length - 1] as any).totalValue
      ? (haveListPages[haveListPages.length - 1] as any).totalValue
      : 0;
    
    return {
      haveListCount,
      haveListValue,
      wantListCount,
      wantListValue,
    };
  }, [haveListData, wantListData]);

  return (
    <div className={`my-cards ${layout.pushProps.className}`} style={layout.pushProps.style}>
      <h1 className="my-cards-title">My Collection</h1>
      <CollectionHeader stats={stats} />
      <TabbedView
        currentTabIndex={tabIndex}
        setTabIndex={onTabIndexChange}
        tabs={tabs}
      />
    </div>
  );
};
